import React from 'react';

import AlertIcon from '@hero/ui-kit/icons/utility/AlertIcon';
import CheckIcon from '@hero/ui-kit/icons/utility/CheckIcon';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import P from '@hero/ui-kit/typography/P';
import * as Style from './style.module.scss';

type Props = {
    checked: boolean;
    onClick: () => void;
    title: string;
    subtitle: string;
    error?: boolean;
};

const RadioButton: React.FC<Props> = ({ title, subtitle, onClick, checked, error }) => {
    return (
        <ClickableOpacity
            alt={checked ? `Check ${title}` : `Uncheck ${title}`}
            className={`${Style.el} ${checked ? Style.checked : ''} ${error ? Style.error : ''}`}
            onClick={onClick}
        >
            <div className={Style.content}>
                <div>
                    <P strong noDefaultMargin>
                        {title}
                    </P>
                    <P noDefaultMargin size="small">
                        {subtitle}
                    </P>
                </div>
            </div>

            {error ? (
                <AlertIcon size="utility" />
            ) : (
                <CheckIcon size="utility" type={checked ? 'brand' : 'utility'} />
            )}
        </ClickableOpacity>
    );
};

export default RadioButton;
